module.exports = __webpack_public_path__ + "img/281aac8.jpg";